import { Box, ContainerProps, SxProps, Theme } from '@mui/material';
import { CenterContainer } from '@/components/blocks/CenterContainer';
import { combineSX } from '@/utils/combineSX';

export interface DpContainerProps extends ContainerProps {
	framesx?: SxProps<Theme>;
	withoutmargin?: boolean;
	isPLP?: boolean;
	clampToViewport?: boolean;
}

export const DpContainer: React.FC<React.PropsWithChildren<DpContainerProps>> = ({
	children,
	component,
	framesx,
	withoutmargin,
	isPLP,
	id,
	clampToViewport,
	...props
}) => (
	<Box
		id={id}
		component={component}
		sx={combineSX([
			{
				width: '100vw',
				...(clampToViewport ? { maxWidth: '100%' } : {}),
				display: 'flex',
				justifyContent: 'center',
				marginBottom: {
					xs: withoutmargin ? '0px' : '40px',
					sm: withoutmargin ? '0px' : '80px',
				},
			},
			...(Array.isArray(framesx) ? framesx : [framesx]),
		])}
	>
		<CenterContainer {...props} isPlP={isPLP ?? false}>
			{children}
		</CenterContainer>
	</Box>
);
